import axios from "axios";

const actions = {
  async listGadget(context, payload) {
    try {
      const response = await this.$api.call("smartphone.listGadget", payload);
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationGadgets", {
          responseData,
          tab: payload.tab,
        });

        // this is used for lazy loading (mobile)
        context.commit("mutationGadgetsAll", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationGadgets", responseData);

        // this is used for lazy loading (mobile)
        context.commit("mutationGadgetsAll", responseData);
      }

      // meta
      context.commit("mutationGadgetsMeta", response.meta);
      return response;
    } catch (error) {
      context.commit("mutationGadgets", []);
      context.commit("mutationGadgetsAll", []);
      context.commit("mutationGadgetsMeta", {});

      throw error;
    }
  },

  async listPolicy(context, payload) {
    try {
      const response = await this.$api.call("smartphone.listPolicy", payload);

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationPolicies", {
          response,
          tab: payload.tab,
        });

        // this is used for lazy loading (mobile)
        context.commit("mutationPoliciesAll", {
          response,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationPolicies", response);

        // this is used for lazy loading (mobile)
        context.commit("mutationPoliciesAll", response);
      }

      return response;
    } catch (error) {
      context.commit("mutationPolicies", []);
      context.commit("mutationPoliciesAll", []);

      throw error;
    }
  },

  async detailPolicy(context, payload) {
    try {
      const response = await this.$api.call("smartphone.detailPolicy", payload);
      const responseData = response.data;

      context.commit("mutationPolicy", responseData);

      return response;
    } catch (error) {
      context.commit("mutationPolicy", {});
      throw error;
    }
  },

  async listClaim(context, payload) {
    try {
      const response = await this.$api.call("smartphone.listClaim", payload);

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationClaims", {
          response,
          tab: payload.tab,
        });

        // this is used for lazy loading (mobile)
        context.commit("mutationClaimsAll", {
          response,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationClaims", response);

        // this is used for lazy loading (mobile)
        context.commit("mutationClaimsAll", response);
      }

      return response;
    } catch (error) {
      context.commit("mutationClaims", []);
      context.commit("mutationClaimsAll", []);

      throw error;
    }
  },

  async detailClaim(context, payload) {
    try {
      const response = await this.$api.call("smartphone.detailClaim", payload);
      const responseData = response.data;

      context.commit("mutationClaim", responseData);

      return response;
    } catch (error) {
      context.commit("mutationClaim", {});
      throw error;
    }
  },

  async listPartners(context, payload) {
    try {
      const response = await this.$api.call("smartphone.listPartners", payload);
      const responseData = response.data;

      context.commit("mutationPartners", responseData);

      return response;
    } catch (error) {
      context.commit("mutationPartners", []);
      throw error;
    }
  },

  async listProduct(context, payload) {
    try {
      const response = await this.$api.call("smartphone.listProduct", payload);
      const responseData = response.data;

      context.commit("mutationProducts", responseData);

      return response;
    } catch (error) {
      context.commit("mutationProducts", {});
      throw error;
    }
  },

  async listProductCategory(context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.listProductCategory",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationProductCategories", responseData);

      return response;
    } catch (error) {
      context.commit("mutationProductCategories", {});
      throw error;
    }
  },

  async downloadAllPolicy(_context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.downloadAllPolicy",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async downloadAllClaim(_context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.downloadAllClaim",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getPresignPolicy(_context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.getPresignPolicy",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getPresign(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.getPresign", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async hitPresignUrl(context, { buffer, url }) {
    try {
      const response = await axios.put(url, buffer, {
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          context.commit(
            "mutationUploadProgress",
            parseInt(Math.round(progress), 10),
          );
        },
      });
      const responseData = response.data;

      // reset uploadProgress to 0 (init state)
      context.commit("mutationUploadProgress", 0);
      return responseData;
    } catch (error) {
      // reset uploadProgress to 0 (init state)
      context.commit("mutationUploadProgress", 0);

      throw error;
    }
  },

  async uploadPolicies(_context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.uploadPolicies",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async updateClaim(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.updateClaim", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  // this is used for lazy loading: reset store
  async resetPolicyAll(context) {
    try {
      context.commit("mutationPoliciesAll", []);
    } catch (error) {
      context.commit("mutationPoliciesAll", []);
      throw error;
    }
  },

  // this is used for lazy loading: reset store
  async resetClaimAll(context) {
    try {
      context.commit("mutationClaimsAll", []);
    } catch (error) {
      context.commit("mutationClaimsAll", []);
      throw error;
    }
  },

  async sharePolicy(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.sharePolicy", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async resendPaymentLink(_context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.resendPaymentLink",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async resendPaymentLinkClaim(_context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.resendPaymentLinkClaim",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  setCreatePolicy(context, payload) {
    context.commit("mutationCreatePolicy", payload);
  },

  async listProductService(context, payload) {
    // const { partnerId } = payload.params;
    // const endpoint = partnerId ? 'smartphone.listProductServiceInsurance' : 'smartphone.listProduct';
    try {
      // const response = await this.$api.call(endpoint, payload);
      const response = await this.$api.call("smartphone.listProduct", payload);
      const responseData = response.data;
      const responseMeta = response.meta;

      context.commit("mutationProductService", responseData);
      context.commit(
        "mutationProductServiceBuybackProgram",
        responseMeta.withBuyBackProgram,
      );
      context.commit("mutationPaymentMethod", {
        disabledPayWithCash: !responseMeta.payWithCash || false,
        disabledPayWithLink: !responseMeta.payWithLink || false,
      });

      return response;
    } catch (error) {
      context.commit("mutationProductService", {});
      throw error;
    }
  },

  async setListProductService(context, payload) {
    context.commit("mutationProductService", payload);
  },

  async listGadgetCategory(context, payload) {
    try {
      const response = await this.$api.call("smartphone.categories", payload);
      const responseData = response.data;

      context.commit("mutationGadgetCategory", responseData);

      return response;
    } catch (error) {
      context.commit("mutationGadgetCategory", {});
      throw error;
    }
  },

  setListGadgetCategory(context, payload) {
    context.commit("mutationGadgetCategory", payload);
  },

  async listBrand(context, payload) {
    try {
      const response = await this.$api.call("smartphone.brand", payload);
      const responseData = response.data;

      context.commit("mutationListBrand", responseData);

      return response;
    } catch (error) {
      context.commit("mutationListBrand", {});
      throw error;
    }
  },

  setListBrand(context, payload) {
    context.commit("mutationListBrand", payload);
  },

  async addPolicy(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.addPolicy", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },
  async updatePolicy(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.updatePolicy", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },
  async addGadget(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.addGadget", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async updateGadget(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.updateGadget", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async deleteGadget(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.deleteGadget", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async updateImei(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.updateImei", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

  setCreateClaim(context, payload) {
    context.commit("mutationCreateClaim", payload);
  },

  setIsValidCreateClaim(context, payload) {
    context.commit("mutationIsValidCreateClaim", payload);
  },

  async searchClaim(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.searchClaim", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async addClaim(_context, payload) {
    try {
      const response = await this.$api.call("smartphone.addClaim", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async addCostEstimation(_context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.addCostEstimation",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async fetchQuestionCostEstimation(context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.fetchQuestionCostEstimation",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationQuestionCostEstimation", responseData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async uploadFilesCostEstimation(context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.uploadFilesCostEstimation",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationFilesCostEstimation", responseData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async manualActivation(_context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.manualActivation",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async listAgent(context, payload) {
    try {
      const response = await this.$api.call("smartphone.listAgent", payload);
      const responseData = response.data;

      context.commit("mutationAgentList", responseData);

      return response;
    } catch (error) {
      context.commit("mutationAgentList", {});
      throw error;
    }
  },

  async editPolicyHistory(context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.editPolicyHistory",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationEditPolicyHistory", responseData);

      return response;
    } catch (error) {
      context.commit("mutationEditPolicyHistory", []);
      throw error;
    }
  },

  async listClaimsHistoriesClaim(context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.claimsHistoriesClaim",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationListClaimsHistoriesClaim", responseData);

      return response;
    } catch (error) {
      context.commit("mutationListClaimsHistoriesClaim", {});
      throw error;
    }
  },

  async listServiceCenter(context, payload) {
    try {
      const response = await this.$api.call(
        "smartphone.listServiceCenter",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationListServiceCenter", responseData);

      return response;
    } catch (error) {
      context.commit("mutationListServiceCenter", {});
      throw error;
    }
  },

  async listProvinceRPX(_context, payload) {
    try {
      const { data } = await this.$api.call("smartphone.listProvince", payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async listCityRPX(_context, payload) {
    try {
      const { data } = await this.$api.call("smartphone.listCities", payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async listDistrictRPX(_context, payload) {
    try {
      const { data } = await this.$api.call("smartphone.listDistrict", payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async listSubDistrictRPX(_context, payload) {
    try {
      const { data } = await this.$api.call(
        "smartphone.listSubDistrict",
        payload,
      );
      return data;
    } catch (error) {
      throw error;
    }
  },

  async checkingCoverageArea(_context, payload) {
    try {
      const { data } = await this.$api.call(
        "smartphone.checkingCoverageArea",
        payload,
      );

      return data;
    } catch (error) {
      throw error;
    }
  },

  async gadgetWalkinToPickupSubmit(_context, payload) {
    try {
      await this.$api.call("smartphone.walkinToPickup", {
        params: {
          claimNumber: payload.claimNumber,
        },
        data: payload.payload,
      });
    } catch (error) {
      throw error;
    }
  },

  async gadgetAddActivityLog(context, payload) {
    try {
      await this.$api.call("smartphone.activityLog", {
        params: {
          claimNumber: payload.claimNumber,
        },
        data: payload.payload,
      });
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
